import { CompPoint } from "@/lib/deriveChartStuff";
import { AnyRegressionResult } from "@/lib/stats";
import * as d3 from "d3";

export const TOOLTIP_WIDTH = 200;
export const MARGIN = { top: 10, right: 10 + TOOLTIP_WIDTH, bottom: 30, left: 90 };

export function getCompRegressionPath(
  comp: CompPoint,
  xScale: d3.ScaleLinear<number, number>,
  yScale: d3.ScaleLinear<number, number>,
  regressionData: AnyRegressionResult,
) {
  const predictedPrice = regressionData.predict(comp.date.getTime());
  if (predictedPrice === null) return null;

  const valueDiff = comp.price - predictedPrice;
  const indexOfCompDate = regressionData.findIndex((a) => a[0] > comp.date.getTime());
  const pointsAfterCompDate = regressionData.slice(indexOfCompDate);

  let trendForComp = pointsAfterCompDate.map((a) => {
    return [a[0], a[1] + valueDiff];
  });

  // without this the trend line starts at the first point AFTER the comp date
  trendForComp = [[comp.date.getTime(), comp.price]].concat(trendForComp);

  const regressionPath = d3
    .line()
    .x((d) => xScale(d[0]))
    .y((d) => yScale(d[1]))(trendForComp.map(([x, y]) => [x, y]));

  return regressionPath;
}

export const pathAnimationProps = {
  transition: {
    type: "tween",
    ease: "easeOut",
  },
  initial: {
    pathLength: 0,
  },
  animate: {
    pathLength: 1,
  },
};
